import { createElement, createRef, Component } from 'react';
import '../uniqueId.js';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { a as _objectSpread, e as _inheritsLoose, f as _defineProperty, g as _assertThisInitialized, c as _extends } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import '../Text/styled.js';
import '../Text/index.js';
import 'reakit/Navigation';
import '../Navigation/styled.js';
import '../chunk-18be6601.js';
import '../Navigation/index.js';
import 'conditional-wrap';
import '../adaptors/fields.js';
import 'reakit/Label';
import 'reakit/Input';
import 'reakit/Hidden';
import '../Hidden/HiddenContainer.js';
import '../Hidden/styled.js';
import '../Hidden/HiddenShow.js';
import '../Hidden/HiddenHide.js';
import '../Hidden/HiddenToggle.js';
import '../Hidden/index.js';
import '../chunk-5c9bbccf.js';
import 'reakit/Popover';
import '../Popover/PopoverContainer.js';
import '../Popover/styled.js';
import '../Popover/PopoverHide.js';
import '../Popover/PopoverClose.js';
import 'focus-trap';
import '../chunk-abb87050.js';
import '../Popover/PopoverPopover.js';
import '../Popover/PopoverShow.js';
import '../Popover/PopoverToggle.js';
import '../chunk-8dd1e1d3.js';
import '../chunk-1195bf9a.js';
import 'reakit/Field';
import '../Label/styled.js';
import '../Label/index.js';
import '../FieldWrapper/styled.js';
import 'reakit/Divider';
import '../Divider/styled.js';
import '../Divider/index.js';
import 'reakit/Group';
import '../Group/styled.js';
import '../Group/index.js';
import 'react-input-mask';
import '../Input/styled.js';
import { b as inputPropTypes, c as inputDefaultProps } from '../Input/InputField-2fb729da.js';
import Input from '../Input/index.js';
import '../Popover/index.js';
import '../Menu/styled.js';
import '../Menu/MenuContext.js';
import '../Menu/MenuTrigger.js';
import '../Menu/MenuButton.js';
import '../Menu/MenuDivider.js';
import '../Menu/MenuGroup.js';
import '../Menu/MenuItem.js';
import '../Menu/MenuPopover.js';
import '../Menu/index.js';
import '../Tag/styled.js';
import '../Tag/index.js';
import { SelectMenuSearchInput as SelectMenuSearchInput$1 } from './styled.js';

var selectMenuSearchInputPropTypes = _objectSpread({}, inputPropTypes);

var selectMenuSearchInputDefaultProps = _objectSpread({}, inputDefaultProps, {
  autoComplete: 'off',
  // @ts-ignore
  before: createElement(Input.Icon, {
    icon: "search"
  }),
  isDropdownActive: false,
  isFullWidth: true,
  placeholder: 'Type to search...'
});

var SelectMenuSearchInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SelectMenuSearchInput, _React$Component);

  function SelectMenuSearchInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "search", createRef());

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var isDropdownActive = _this.props.isDropdownActive;
      var prevIsDropdownActive = prevProps.isDropdownActive;

      if (isDropdownActive && !prevIsDropdownActive) {
        requestAnimationFrame(function () {
          return _this.search.current && _this.search.current.focus();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var props = _extends({}, _this.props);

      return createElement(SelectMenuSearchInput$1, _extends({}, props, {
        inputRef: _this.search
      }));
    });

    return _this;
  }

  return SelectMenuSearchInput;
}(Component);

_defineProperty(SelectMenuSearchInput, "propTypes", selectMenuSearchInputPropTypes);

_defineProperty(SelectMenuSearchInput, "defaultProps", selectMenuSearchInputDefaultProps);

export default SelectMenuSearchInput;
export { SelectMenuSearchInput, selectMenuSearchInputDefaultProps, selectMenuSearchInputPropTypes };